import { Stack, IconButton } from "@mui/material/";
import {
  ContentPaste,
  Download,
  Refresh,
  ThumbDown,
  ThumbUp,
} from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";

export type AssistantMessageActionBarProps = {
  onRegenerateMessage: () => void;
  onCopyMessage: () => void;
  onMessageDownload: () => void;
  onGoodFeedback: () => void;
  onBadFeedback: () => void;
  disableFeedback: boolean;
};

export default function AssistantMessageActionBar({
  onRegenerateMessage,
  onCopyMessage,
  onMessageDownload,
  onGoodFeedback,
  onBadFeedback,
  disableFeedback,
}: AssistantMessageActionBarProps) {
  return (
    <Box maxWidth="960px" width="100%">
      <Stack direction="row">
        <Tooltip title="Try this one again">
          <IconButton onClick={onRegenerateMessage}>
            <Refresh />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy this message to the clipboard">
          <IconButton onClick={onCopyMessage}>
            <ContentPaste />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download a copy of this message">
          <IconButton onClick={onMessageDownload}>
            <Download />
          </IconButton>
        </Tooltip>
        <Tooltip title="Good response">
          <IconButton onClick={onGoodFeedback} disabled={disableFeedback}>
            <ThumbUp />
          </IconButton>
        </Tooltip>
        <Tooltip title="Bad response">
          <IconButton onClick={onBadFeedback} disabled={disableFeedback}>
            <ThumbDown />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
}
